import DataLoadingGif from './DataLoadingGif';
import styles from './PageLoader.module.css';

/**
 * Full-viewport loading (auth bootstrap, route Suspense).
 */
function PageLoader() {
    return (
        <div className={styles.wrap} role="status" aria-live="polite" aria-label="Loading">
            <DataLoadingGif size="xl" label="Loading…" />
        </div>
    );
}

export default PageLoader;
